import { useEffect } from "react";

// Applies the Co-Work pages' own favicon (Admin > Co-Work > Browser Title & Logo) while a Co-Work page is
// open, and puts the site favicon back when the visitor leaves. With no Co-Work favicon set, the site
// favicon stays. `settings` is the response of /core/cowork/settings/ (null until loaded).
//
// The site-wide favicon (App.js) loads asynchronously and may finish AFTER this one, so the link is
// watched and the Co-Work favicon is re-applied if something else changes it while the page is open.
export default function useCoWorkBranding(settings) {
  const favicon = settings?.favicon;

  useEffect(() => {
    if (!favicon) return undefined;
    let link = document.querySelector("link[rel='icon']");
    const created = !link;
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    const previous = link.getAttribute("href");
    const apply = () => { if (link.getAttribute("href") !== favicon) link.setAttribute("href", favicon); };
    apply();

    const observer = new MutationObserver(apply);
    observer.observe(link, { attributes: true, attributeFilter: ["href"] });

    return () => {
      observer.disconnect();
      if (created) link.remove();
      else if (previous) link.setAttribute("href", previous);
    };
  }, [favicon]);
}
